var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClient3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3184 3.89917C20.7187 6.33636 20.7313 8.87419 20.1543 11.2419L20.0234 11.74C18.9028 15.7171 15.482 18.6609 10.4141 20.1375C9.82518 17.288 9.6018 15.1649 10.2246 13.156C10.8824 11.0343 12.5114 8.95434 15.8984 6.29468C17.2173 5.25894 18.7096 4.57668 20.2227 3.93823C20.256 3.92423 20.2881 3.91182 20.3184 3.89917Z",
    stroke: "#636980",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0409 16.6431C8.02449 14.9415 8.32449 13.4087 8.84715 12.0329C8.24715 11.3321 7.5159 10.6688 6.64168 10.0431C5.61746 9.30947 4.51355 8.70478 3.40965 8.22432C3.02293 8.05557 2.91746 8.01807 2.91746 8.01807C2.91746 8.01807 2.90105 8.11182 2.89168 8.15869C2.51902 10.2493 2.50262 12.4712 3.06277 14.522C3.83152 17.3345 5.59402 19.4556 8.62918 20.6813C8.39246 19.8165 8.23308 18.9892 8.13933 18.1923L8.0409 16.6431ZM8.0409 16.6431L5.05262 11.161",
    stroke: "#636980",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20L18 8",
    stroke: "#636980",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient3);
export default __webpack_public_path__ + "static/media/Client 3.ebd1b673ef004aed7adf2d5928c9a7b9.svg";
export { ForwardRef as ReactComponent };